const madmaxPath = "framework/";
const gamePath = "";

const gameset = {
	stageWidth: 1280,
	stageHeight: 720,
	loadGraphics: "c",
	preferGraphics: "h",
	amaTitle: "Multi Diamonds 81",
	gameName: "Multi Diamonds 81",
	mute: false,
	gameType: "reel",
	currency: "cents",
	game_id: "multi_diamonds_81",
	casino_id: 0,
	uxtype: "mobile",
	gameSign: "Multi Diamonds 81",
	version: "h",
	language: "en",
	lineGameType: "normal", //"normal", "lines", "levels"

	preloader: {},
	scripts: [
		"framework/src/vendor/jquery.min.js",
		"framework/src/vendor/tween.js",
	],

	infoPages: {
		separated: true,
	},

	system: {
		audio: {
			tracks: [
				{
					name: "ui_Btn_Generic",
					url: madmaxPath + "assets/audio/ui_Btn_Generic.{ogg,mp3}",
					classVol: "volume.buttonEffect",
				},
				{
					name: "ui_Btn_Up",
					classVol: "volume.buttonEffect",
					reference: "ui_Btn_Generic",
				},
				{
					name: "ui_Btn_Down",
					classVol: "volume.buttonEffect",
					reference: "ui_Btn_Generic",
				},
				{
					name: "button_click",
					reference: "ui_Btn_Generic",
				},
                {
                    name: 'Jackpot_sound',
                    url: `${gamePath}assets/JokerWinBanner/Jackpot_sound.{ogg,mp3}`,
                    classVol: 'volume.normalWin',
                    loop: false,
                },
                {
                    name: 'JokerBonus_alert',
                    url: `${gamePath}assets/JokerWinBanner/JokerBonus_alert.{ogg,mp3}`,
                    classVol: 'volume.normalWin',
                    loop: false,
                },
			],
		},
	},
	game: {
		basic: {
			symbolsCount: 9,
			slotsCount: 12,
			slotsRows: 3,
			slotsColumns: 4,
			pilarsCount: 4,
		},
		webfonts: ["UbuntuMono-Regular", "Audiowide-Regular"],
		layers: [
			"reelStage2",
			"reels",
			"winSymbols",
			"black",
			"anims",
			"touchZone",
			"winFactors",
			"reelStage",
			{
				name: "lights",
				layers: ["base", "one", "two"],
			},
			"counter",
			"logo",
			{
				name: "info",
				layers: ["bg", "pageOne", "pageTwo", "pageThree", "arrow"],
			},
			"preloader",
		],
		subLayers: [
			// {
			//     "layer": "info",
			//     "layers": [
			//         "bg",
			//         "pageOne",
			//         "pageTwo",
			//         "pageThree",
			//         "arrow"
			//     ]
			// },
			// {
			//     "layer": "lights",
			//     "layers": [
			//         "base",
			//         "one",
			//         "two"
			//     ]
			// }
		],

		totalBackgroundUrl: madmaxPath + "asets/img/totalbackground.png",
		audio: {
			tracks: [
				{
					name: "ui_Counter",
					url: madmaxPath + "assets/audio/ui_Counter.{ogg,mp3}",
					loop: true,
					classVol: "volume.winCounter",
				},
				{
					name: "ui_Counter_Stop",
					url: madmaxPath + "assets/audio/ui_Counter_Stop.{ogg,mp3}",
					loop: false,
					classVol: "volume.winCounter",
				},
				{
					name: "reel_Spin",
					url: gamePath + "assets/audio/reel_Spin.{ogg,mp3}",
					loop: false,
					classVol: "volume.startReel",
				},
				{
					name: "reel_Stop",
					url: gamePath + "assets/audio/reel_Stop.{ogg,mp3}",
					loop: false,
					classVol: "volume.stopReel",
				},
				{
					name: "symbol_Wild",
					url: gamePath + "assets/audio/symbol_Wild.{ogg,mp3}",
					loop: false,
					classVol: "miscSounds.miscSounds1",
				},
				{
					name: "win_High",
					url: gamePath + "assets/audio/win_High.{ogg,mp3}",
					loop: false,
					classVol: "volume.normalWin",
				},
				{
					name: "win_Low",
					url: gamePath + "assets/audio/win_Low.{ogg,mp3}",
					loop: false,
					classVol: "volume.normalWin",
				},
				{
					name: "win_x2",
					url: gamePath + "assets/audio/win_x2.{ogg,mp3}",
					loop: false,
					classVol: "volume.winAnim",
				},
				{
					name: "win_x4",
					url: gamePath + "assets/audio/win_x4.{ogg,mp3}",
					loop: false,
					classVol: "volume.winAnim",
				},
				{
					name: "win_x8",
					url: gamePath + "assets/audio/win_x8.{ogg,mp3}",
					loop: false,
					classVol: "volume.winAnim",
				},
				{
					name: "bWin",
					url: gamePath + "assets/audio/bWin.{ogg,mp3}",
					loop: false,
					classVol: "volume.bigWin",
				},
			],
			playlists: [],
		},
		fonts: {
			fontFamilies: [
				{
					name: "wintable-export",
					type: "standard",
				},
			],
			defaultFamily: "wintable-export",
			fontSet: [
				{
					name: "text",
					family: "wintable-export",
					align: "left",
					fontSize: 20,
					anchor: [0.5, 0.5],
					isDefault: true,
					fill: "0xFFD700",
					fontFamily: "Arial",
					fontWeight: "bold",
					wordWrap: true,
					wordWrapWidth: 1040,
				},
			],
		},
		infoSymbolsPosition: {
			x: [730, 190],
			y: [555, 480, 395, 310],
		},
		infoSymbolsScale: {
			scale: [0.46, 0.52, 0.6, 0.68],
		},
		infoFactorPosition: {
			x: [830, 960, 1090, 290, 420],
			y: [555, 480, 395],
		},
		symbolModel: {
			enabled: true,
			animationType: "move",
			symbolType: "basic",
			animationDelayStart: 300,
			animationDelayStop: 300,
			matrixColumn: 4,
			matrixRow: 3,
			symbolSize: {
				width: 180,
				height: 202,
			},
			baseMatrix: {
				x: [200, 498, 787, 1081],
				y: [140, 140, 140, 140],
			},
			staticSymbols: {},
			touchZone: {
				width: 180,
				height: 180,
				reels: ["right", "right", "left", "left"],
				table: "winfactor_background.png",
				numbers: "winFactor_factors.png",
				font: "wintable-export",
				factors: 2,
			},
		},
		symbols: [
			{
				textureName: "symbol_Orange.png",
				name: "symbol_Orange",
				animations: [],
				id: 0,
				textures: {
					main: "symbol_orange",
					blur: "symbol_orange_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Blue.png",
				name: "symbol_Blue",
				animations: [],
				id: 1,
				textures: {
					main: "symbol_blue",
					blur: "symbol_blue_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Red.png",
				name: "symbol_Red",
				animations: [],
				id: 2,
				textures: {
					main: "symbol_red",
					blur: "symbol_red_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Green.png",
				name: "symbol_Green",
				animations: [],
				id: 3,
				textures: {
					main: "symbol_green",
					blur: "symbol_green_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Purple.png",
				name: "symbol_Purple",
				animations: [],
				id: 4,
				textures: {
					main: "symbol_purple",
					blur: "symbol_purple_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Crown.png",
				name: "symbol_Crown",
				animations: [],
				id: 5,
				textures: {
					main: "symbol_crown",
					blur: "symbol_crown_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Star.png",
				name: "symbol_Star",
				animations: [],
				id: 6,
				textures: {
					main: "symbol_star",
					blur: "symbol_star_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Seven.png",
				name: "symbol_Seven",
				animations: [],
				id: 7,
				textures: {
					main: "symbol_seven",
					blur: "symbol_seven_blur",
				},
				textureSufix: ".png",
			},
			{
				textureName: "symbol_Wild.png",
				name: "symbol_Wild",
				animations: [],
				id: 8,
				textures: {
					main: "symbol_wild",
					blur: "symbol_wild_blur",
				},
				textureSufix: ".png",
			},
		],

		info: {
			enabled: false,
			pages: 2,
		},
		h: {
			sprites: [
				gamePath + "assets/anim/symbol_blue/symbol_Blue_parts.json",
				gamePath + "assets/anim/symbol_crown/symbol_Crown_parts.json",
				gamePath + "assets/anim/symbol_green/symbol_Green_parts.json",
				gamePath + "assets/anim/symbol_orange/symbol_Orange_parts.json",
				gamePath + "assets/anim/symbol_purple/symbol_Purple_parts.json",
				gamePath + "assets/anim/symbol_red/symbol_Red_parts.json",
				gamePath + "assets/anim/symbol_seven/symbol_Seven_parts.json",
				gamePath + "assets/anim/symbol_star/symbol_Star_parts.json",
				gamePath + "assets/anim/symbol_wild/symbol_Wild_parts.json",
				gamePath + "assets/anim/symbol_blur.json",
				gamePath + "assets/anim/x248_parts.json",

				gamePath + "assets/anim/common_parts.json",

				gamePath + "assets/anim/rest.json",
				gamePath + "assets/anim/info.json",
				gamePath + "assets/font/wintable-export.xml",
				gamePath + "assets/img/coins.json",
				gamePath + "assets/img/counter.json",
			],
			assets: [
				{
					name: "background_reels",
					url: gamePath + "assets/img/reels_background.png",
					type: "Image",
					set: {
						x: 0,
						y: 0,
						width: 1280,
						height: 720,
					},
				},
				// {
				//     "name": "leftArr",
				//     "url": gamePath + "assets/info/btn_arrow_left_basic.svg",
				//     "type": "Image"
				// },
				// {
				//     "name": "leftArr2",
				//     "url": madmaxPath + "assets/img/ux/mblbtn/btn_arrow_left.png",
				//     "type": "Image"
				// },
				// {
				//     "name": "leftArrPressed",
				//     "url": gamePath + "assets/info/btn_arrow_left_pressed.svg",
				//     "type": "Image"
				// }
			],
		},
		rest: [
			{
				textureName: "button_freespins_pressed.png",
				name: "button_freespins_pressed",
			},
			{
				textureName: "winlines.png",
				name: "winlines.png",
			},
		],

		grelems: [
			{
				name: "background_reels",
				frame: "background_reels",
				layer: "reelStage2",
				sufix: "",
				layerId: 0,
				type: "Image",
				defaultAddToLayer: true,
				alpha: 1,
				sourceFormat: "image",
				set: {
					x: 1,
					y: 1,
				},
				scale: {
					x: 1,
					y: 1,
				},
			},
			{
				name: "reels_background_layer_2",
				frame: "reels_background_layer_2.png",
				layer: "reelStage",
				sufix: "",
				layerId: 0,
				type: "Image",
				defaultAddToLayer: true,
				alpha: 1,
				sourceFormat: "image",
				set: {
					x: 0,
					y: 0,
				},
				scale: {
					x: 1,
					y: 1,
				},
			},
			{
				name: "logo",
				frame: "logo.png",
				layer: "logo",
				sufix: "",
				layerId: 0,
				type: "Image",
				defaultAddToLayer: true,
				alpha: 1,
				sourceFormat: "image",
				set: {
					x: 640,
					y: 1,
				},
				scale: {
					x: 1,
					y: 1,
				},
				anchor: {
					x: 0.5,
					y: 0,
				},
			},
		],
	},
};

export default gameset;
